import { z } from 'zod'

import { baseStructuredSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-structured.schema'

export const otherSchema = baseStructuredSchema.safeExtend({
  instrument_type: z.literal('other'),
  // @ts-ignore
  fund_id: z.number().int().optional().nullable(),
})

export type OtherSchemaType = z.infer<typeof otherSchema>
